import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const handleBuyClick = () => {
    trackAddToCart();
    setTimeout(() => {
      window.open('https://legadosalud.com/cart/42376387199061:1', '_blank', 'noopener,noreferrer');
    }, 300);
  };
  return <section id="pricing" className="py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-32">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 to-navy-800 -z-20" data-id="element-33"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[120px] -z-10" data-id="element-34"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-35">
        <FadeIn data-id="element-36">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-37">
            Accede a un sueño reparador hoy mismo.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-38">
          <div className="bg-navy-900/80 backdrop-blur-sm border border-amber-500/30 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto shadow-2xl" data-id="element-39">
            <div className="flex justify-center mb-8" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/gyV8V8MwVnM4G2dy1xznwF/Portada_SuenoProfundoSP.png" alt="Sueño Profundo Cover" className="w-48 rounded-lg shadow-lg" data-id="element-41" />
            </div>

            <div className="mb-8" data-id="element-42">
              <span className="text-lavender-200 text-lg uppercase tracking-wider font-bold" data-id="element-43">
                Precio
              </span>
              <div className="flex items-center justify-center gap-4 my-2" data-id="element-44">
                <span className="text-2xl md:text-3xl text-lavender-300 line-through" data-id="element-45">
                  $19,99
                </span>
                <span className="text-5xl md:text-6xl font-bold text-amber-500" data-id="element-46">
                  $6,39
                </span>
              </div>
              <span className="text-lavender-300" data-id="element-47">(Pago único)</span>
            </div>

            <Button onClick={handleBuyClick} className="w-full py-5 text-xl mb-6" data-id="element-48">
              QUIERO DORMIR BIEN OTRA VEZ
            </Button>

            <div className="flex flex-col items-center gap-3 text-sm text-lavender-200" data-id="element-49">
              <div className="flex items-center gap-2" data-id="element-50">
                <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-51" />
                <span data-id="element-52">Compra segura.</span>
              </div>
              <p data-id="element-53">Acceso instantáneo en PDF tras el pago.</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}